import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { TrashIcon } from '@components/drive/driveIcons';
import Actions from '../../../../../../../../../store/actions';
import deleteRole from '../RoleDetails/deleteRole';
import { FormatTypes } from '../../../../../../../../../constants/templateDictionaries';
import scrollToSlateNode from '../utils/scrollToSlateNode';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';

const DeleteWrapper = styled.span`
  margin-left: 0.75rem;
  pointer-events: auto;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};

  &:hover {
    svg path:first-child {
      fill: ${(props) => props.rolesCount > 1 && '#473880'};
    }
  }

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'publication') {
      return css`
        grid-row: 1 / span 1;
        grid-column: 1 / span 1;
        justify-self: center;
        align-self: center;
        margin-left: 0;
      `;
    }

    if (
      nodeType === 'skill_title' ||
      nodeType === 'language' ||
      nodeType === 'hobbies_and_interests' ||
      nodeType === 'personal_link'
    ) {
      return css`
        margin-left: 0;
      `;
    }

    return null;
  }}
`;

const DeleteItem = (props) => {
  const handleDelete = (e) => {
    e.preventDefault();
    const { node, editor, mostUsedToolSetRef } = props;
    deleteRole({
      editor,
      currentRole: node,
      mostUsedToolSetRef,
      props,
    });
  };

  const deleteItem = (e) => {
    const { node, editor, mostUsedToolSetRef } = props;

    const {
      value: { document },
    } = editor;
    const { key: nodeKey } = node;
    const { nodes: documentNodes } = document.getParent(nodeKey);

    e.preventDefault();
    if (
      documentNodes.size === 1 ||
      (documentNodes.size === 3 && node.type === 'skill_title')
    )
      return;
    editor.removeNodeByKey(nodeKey);

    const { data: documentData } = document;

    const documentDataJSON = documentData.toJSON();

    const { data: nodeData } = node;
    const nodeDataJSON = nodeData.toJSON();

    let focusableNode;
    const nextBlock = document.getNextBlock(nodeKey);
    if (nextBlock) {
      focusableNode = nextBlock;
    } else {
      const previousPara = document.getPreviousBlock(nodeKey);
      focusableNode = previousPara;
    }

    if (nodeDataJSON.toExport) {
      editor
        .setNodeByKey(document.key, {
          data: {
            ...documentDataJSON,
            selectAll: documentDataJSON.selectAll - 1,
            toExport: documentDataJSON.selectAll - 1 !== 0,
          },
        })
        .moveToEndOfNode(focusableNode);
    }
    editor.moveToEndOfNode(focusableNode);
    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
    scrollToSlateNode(focusableNode, mostUsedToolSetRef, props);
  };

  const { node, rolesCount } = props;
  const { type } = node;

  const clickHandler = (e) => {
    if (type === 'skill_title') handleDelete(e);
    else deleteItem(e);
  };

  return (
    <DeleteWrapper
      nodeType={type}
      onClick={clickHandler}
      data-testid={`${type}_delete`}
      rolesCount={rolesCount}
      disabled={rolesCount <= 1}
    >
      <TrashIcon width="16px" height="16px" />
    </DeleteWrapper>
  );
};

DeleteItem.propTypes = {
  node: propTypes.objectOf(propTypes.object).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func,
  }).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;

  let userPreferences;
  if (formatType === FormatTypes.RESUME) {
    ({ userPreferences } = state.editResumeFormReducer);
  }
  return {
    userPreferences,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUserPreferences: (params) =>
    dispatch(Actions.editDocumentFormActions.updateUserPreferences(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteItem);
